import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getReferral,
  createReferral,
  editReferral,
  deleteReferral,
} from "../../store/reward/reward.action";
import { FormControl, TextField, Select, MenuItem } from "@mui/material";
import Button from "../../extra/Button";

const ReferralReward = (props) => {
  const dispatch = useDispatch();
  const { referral } = useSelector((state) => state.reward);
  // const [referralNameError, setReferralNameError] = useState('');
  const [referralCoinError, setReferralCoinError] = useState("");
  const [reqReferralError, setReqReferralError] = useState("");
  const [underSubmisson, setUnderSubmission] = useState(false);
  // const [referralName, setReferralName] = useState('');
  const [referralCoin, setReferralCoin] = useState("");
  const [referralRequired, setReferralRequired] = useState("");
  const [isActive, setIsActive] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!referralName) {
    //     setReferralNameError('Referral Reward is required');
    //     return;
    // }
    if (!referralCoin) {
      setReferralCoinError("Referral Coin is required");
      return;
    }
    if (!referralRequired) {
      setReqReferralError("Referral Required is required");
      return;
    }
    setUnderSubmission(true);
    const body = {
      coins: parseInt(referralCoin),
      isActive,
    };
    const IntreferralRequired = parseInt(referralRequired);
    if (referral[0]) {
      if (IntreferralRequired !== referral[0].totalReferral) {
        body.totalReferral = IntreferralRequired;
      }
      props.editReferral(body, referral[0]._id);
    } else {
      body.totalReferral = IntreferralRequired;
      props.createReferral(body);
    }
    setUnderSubmission(false);
  };
  useEffect(() => {
    dispatch(getReferral());
  }, [dispatch]);

  useEffect(() => {
    // console.log("CategoryData", categoryData);
    if (referral[0]) {
      setReferralCoin(String(referral[0].coins) || "");
      setIsActive(referral[0].isActive);
      setReferralRequired(String(referral[0].totalReferral) || "");
    }
  }, [referral]);
  return (
    <div
      className="row search-action"
      style={{
        paddingRight: "3px",
        display: "flex",
        width: "fit-content",
        justifyContent: "center",
        border: "1px solid rgba(128, 128, 128, 0.4)",
        padding: "16px",
        borderRadius: "20px",
      }}
    >
      <h5
        style={{
          fontWeight: "500",
          fontSize: "20px",
          marginTop: "5px",
          marginBottom: "4px",
        }}
      >
        Referral Reward
      </h5>
      <form onSubmit={handleSubmit}>
        <FormControl
          sx={{
            m: 2,
            minWidth: 120,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {/* <TextField id="outlined-basic" variant="outlined"
                        label="Enter Referral Name"
                        value={referralName}
                        onChange={(e) => setReferralName(e.target.value)}
                        error={referralNameError}
                        sx={{
                            width: "100%",
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '9999px',
                                border: 'none',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '&:hover fieldset': {
                                    border: 'none',
                                },
                                '&.Mui-focused fieldset': {
                                    borderWidth: '1px',
                                }
                            }
                        }}
                    /> */}
          <div
            style={{
              paddingRight: "3px",
              display: "flex",
              alignItems: "center",
              padding: "16px",
              gap: "10px",
            }}
          >
            <TextField
              id="outlined-basic"
              variant="outlined"
              label="Referral Required"
              value={referralRequired}
              onChange={(e) => setReferralRequired(e.target.value)}
              error={reqReferralError}
              sx={{
                width: "100%",

                "& .MuiOutlinedInput-root": {
                  borderRadius: "9999px",

                  border: "none",
                  "&:hover fieldset": {
                    borderWidth: "1px",
                  },
                  "&.Mui-focused fieldset": {
                    borderWidth: "1px",
                  },
                },
              }}
            />
            <span>-</span>
            <TextField
              id="outlined-basic"
              variant="outlined"
              label="Referral Reward"
              value={referralCoin || ""}
              onChange={(e) => setReferralCoin(e.target.value)}
              error={referralCoinError}
              sx={{
                width: "100%",

                "& .MuiOutlinedInput-root": {
                  borderRadius: "9999px",
                  border: "none",
                  "&:hover fieldset": {
                    borderWidth: "1px",
                  },
                  "&.Mui-focused fieldset": {
                    borderWidth: "1px",
                  },
                },
              }}
            />
          </div>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            sx={{
              width: "150px",
              borderRadius: "9999px",
              mb: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "9999px", // Make the input fully rounded
                padding: "8px 16px", // Adjust padding for a better look
              },
              "& .MuiSelect-select": {
                borderRadius: "9999px",
              },
            }}
          >
            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Deactive</MenuItem>
          </Select>
        </FormControl>

        <Button
          newClass={"submit-btn-dialogue py-2"}
          type={"submit"}
          disabled={underSubmisson}
          btnName={referral.length > 0 ? "Update" : "Create"}
          style={{ marginRight: "10px" }}
        />
      </form>
    </div>
  );
};

export default connect(null, {
  getReferral,
  createReferral,
  editReferral,
})(ReferralReward);
